import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarLink,
    SidebarMenu
} from "./SidebarElems" 

export default function Sidebar({isOpen, toggle}) {
  return (
    <>
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink to='about' onClick={toggle}>
                        About
                    </SidebarLink>
                    <SidebarLink to='hobbies' onClick={toggle}>
                        Hobbies
                    </SidebarLink>
                    <SidebarLink to='education' onClick={toggle}>
                        Education
                    </SidebarLink>
                    <SidebarLink to='experience' onClick={toggle}>
                        Experience
                    </SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    </>
  )
}
